/**
 * React Query hook for the Buildings listing.
 *
 * Contract requirements:
 *  - keepPreviousData: true → stale data stays visible while new page is loading.
 *  - Errors are not swallowed — they propagate to React Query `error` state.
 *  - The QueryClient is created outside the render body by the feature mount (task-08);
 *    this hook only consumes it via useQuery.
 *  - Query key is built deterministically by buildingsQueryKey().
 */
import { useQuery } from '@tanstack/react-query';
import { fetchBuildings } from '../services/BuildingsService';
import { buildingsKeys } from './queryKeys';
/**
 * Fetches buildings for the given normalized state.
 *
 * Errors thrown by fetchBuildings() are surfaced as `error` in the returned
 * query result — callers must handle the error state explicitly (no swallowing).
 */
export function useBuildingsQuery(state, options = {}) {
    return useQuery(buildingsKeys.listing(state), () => fetchBuildings(state), {
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        enabled: options.enabled !== false
        // Errors propagate — do NOT add onError swallowing
    });
}
